import { useState } from 'react';

const defaultFilters = (orgId, buildingId) => ({
  orgId,
  buildings: buildingId ? [buildingId] : [],
  date: null,
});

/**
 * Helper state for a buildings + dates context, used by the dashboard and changelog pages
 * Includes an organization id so that super-admins can look at other orgs' pages
 */
const useDatedBuildings = ({ orgId, buildingId }) => {
  const [filters, setFilters] = useState(defaultFilters(orgId, buildingId));
  const resetFilters = () => setFilters(defaultFilters(orgId));
  return [filters, setFilters, resetFilters];
};

export default useDatedBuildings;
